import { useEffect, useState } from "react";
import { TestQuestionIndex } from "./Components/Test-question-card";
import "./MockTest.scss";
import { TestSteps, TestTypes } from "@Constants/app.constant";
import { InstructionIndex } from "./Instruction";
import { Navigate, useLocation, useNavigate, useParams } from "react-router-dom";
import { getTestDetails, getTestSeriesDetails } from "../TestDetails/services/TestDetails.service";
import { APIResponse, APIStatus } from "@Src/services/baseInterfaces";
import { AppRouteURL, TestRouteURL, TestSereisRouteURL } from "@Constants/app-route-url.constant";

export const TestIndex = () => {
    const params = useParams();
    const navigate = useNavigate();
    const locationn = useLocation();
    const testId = params.testId;
    const examId = params.examId;
    const [step, setStep] = useState(0);
    const [testDeatils, setTestDeatils] = useState<any>([]);
    const testType = TestTypes.regular;
    const [isTestSeries, setIsTestSeries] = useState<boolean>(false);

    useEffect(() => {
        if (location.pathname.includes(`${TestRouteURL.TEST_SERIES}`) || location.pathname.includes(`${TestSereisRouteURL.FULL_MOCK_TEST_SERIES}`) || location.pathname.includes(`${TestSereisRouteURL.PREVIOUS_YEAR_MOCK_TEST_SERIES}`)) {
            setIsTestSeries(true);
            getAllTestSeriesDetails();
        } else {
            setIsTestSeries(false);
            getAllTestDetails();
        }
    }, [testId, examId]);


    function getAllTestDetails() {
        let param = {
            "testId": testId,
        }
        getTestDetails(param).then((response: APIResponse) => {
            if (response?.ResponseType == APIStatus.SUCCESS && locationn.state?.flagTest == testId) {
                let data = response?.data;
                setTestDeatils(data);
                setStep(TestSteps.INSTRUCTION)
            } else if (response?.ResponseType === "DATA_NOT_FOUND" && !response?.data) {
                navigate(AppRouteURL.NOT_FOUND);
            } else {
                navigate(AppRouteURL.NOT_FOUND)
            }
        }).catch((error) => {
            console.log(error);
            navigate(AppRouteURL.NOT_FOUND)
        })
    }
    function getAllTestSeriesDetails() {
        let param = {
            "examId": examId,
        }
        getTestSeriesDetails(param).then((response: APIResponse) => {
            if (response?.ResponseType == APIStatus.SUCCESS && locationn.state?.flagTest == examId) {
                let data = response?.data;
                setTestDeatils(data);
                setStep(TestSteps.INSTRUCTION)
            } else if (response?.ResponseType === "DATA_NOT_FOUND" && !response?.data) {
                navigate(AppRouteURL.NOT_FOUND);
            } else {
                navigate(AppRouteURL.NOT_FOUND)
            }
        }).catch((error) => {
            console.log(error);
            navigate(AppRouteURL.NOT_FOUND)
        })
    }


    const onContinueClickHandler = () => {
        setStep(TestSteps.START_TEST);
    }

    return (
        <>
            {step == TestSteps.INSTRUCTION ?
                isTestSeries ?
                    <InstructionIndex maxMarks="0" noOfQuestion={testDeatils.NoOfQues} timeDuration={testDeatils.Duration} onContinueClickHandler={onContinueClickHandler} testType={testType} isTestSeries={isTestSeries} testName={testDeatils.Name} instruction={testDeatils.Instruction}/>
                    : <InstructionIndex maxMarks="0" noOfQuestion={testDeatils[0].NoOfQues} timeDuration={testDeatils[0].Duration} onContinueClickHandler={onContinueClickHandler} testType={testType} isTestSeries={isTestSeries} testName={testDeatils[0].TestName} instruction={testDeatils[0].Instruction} />
                : ''}
            {step == TestSteps.START_TEST ?
                isTestSeries ?
                    <TestQuestionIndex testId={examId} noOfQuestion={testDeatils.NoOfQues} timeDuration={testDeatils.Duration} isTestSeries={isTestSeries} testIds={testDeatils.TestIdList} testName={testDeatils.Name} generalInstruction={testDeatils.Instruction} />
                    : <TestQuestionIndex testId={testId} noOfQuestion={testDeatils[0].NoOfQues} timeDuration={testDeatils[0].Duration} isTestSeries={isTestSeries} testIds={[]} testName={testDeatils[0].TestName} generalInstruction={testDeatils[0].Instruction}/>
                : ''
            }
        </>
    );
};
